// ./src/contexts/RentalAssetsContext/RentalAssetsContext.tsx
//
// Thin context wrapper around the useRentalAssets hook. All derived data lives in
// the hook itself. Mirrors CouponTypesContext — mounted on the account Library
// page and (with an eventId) on the event Rentals page so its asset picker can
// list + create assets in place.

import React, { createContext, useContext } from "react";

import { useRentalAssets, UseRentalAssetsOptions, UseRentalAssetsReturn } from "@/hooks/useRentalAssets";

const RentalAssetsContext = createContext<UseRentalAssetsReturn | null>(null);

export interface RentalAssetsProviderProps extends UseRentalAssetsOptions {
  children: React.ReactNode;
}

export const RentalAssetsProvider: React.FC<RentalAssetsProviderProps> = ({ children, ...options }) => {
  const value = useRentalAssets(options);

  return <RentalAssetsContext.Provider value={value}>{children}</RentalAssetsContext.Provider>;
};

export const useRentalAssetsContext = (): UseRentalAssetsReturn => {
  const context = useContext(RentalAssetsContext);

  if (!context) {
    throw new Error(
      "useRentalAssetsContext must be used within a <RentalAssetsProvider>. " +
        "Wrap your component tree with <RentalAssetsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalRentalAssetsContext = (): UseRentalAssetsReturn | null => {
  return useContext(RentalAssetsContext);
};
